import { TableCellLayout, Tooltip } from '@fluentui/react-components';
import {
    ArrowSyncCircle24Regular,
    CheckmarkCircle24Regular,
    DismissCircle24Regular,
    ErrorCircle24Regular,
    Eye24Regular,
} from '@fluentui/react-icons';
import { BroadcastMessageStatistics } from '../../../../../model';
import { useBroadcastMessageStatsStyles } from './BroadcastMessageStats.styles';

export interface BroadcastMessageStatsProps {
    data: BroadcastMessageStatistics;
}

const BroadcastMessageStats: React.FC<BroadcastMessageStatsProps> = ({
    data,
}) => {
    const styles = useBroadcastMessageStatsStyles();

    return (
        <div className={styles.root}>
            <Tooltip
                content={'Pending sending'}
                withArrow
                relationship="description"
            >
                <TableCellLayout
                    media={
                        <ArrowSyncCircle24Regular
                            className={styles.pendingSendingIcon}
                        />
                    }
                >
                    {data.pendingSendingCount.toString()}
                </TableCellLayout>
            </Tooltip>
            <Tooltip
                content={'Successfully delivered'}
                withArrow
                relationship="description"
            >
                <TableCellLayout
                    media={
                        <CheckmarkCircle24Regular
                            className={styles.successfullySentIcon}
                        />
                    }
                >
                    {data.successfullySentCount.toString()}
                </TableCellLayout>
            </Tooltip>
            <Tooltip content={'Throttled'} withArrow relationship="description">
                <TableCellLayout
                    media={
                        <ErrorCircle24Regular
                            className={styles.throttledIcon}
                        />
                    }
                >
                    {data.throttledCount.toString()}
                </TableCellLayout>
            </Tooltip>
            <Tooltip content={'Failed'} withArrow relationship="description">
                <TableCellLayout
                    media={
                        <DismissCircle24Regular
                            className={styles.sendFailedIcon}
                        />
                    }
                >
                    {data.sendFailedCount.toString()}
                </TableCellLayout>
            </Tooltip>
            <Tooltip
                content={'Already seen'}
                withArrow
                relationship="description"
            >
                <TableCellLayout
                    media={<Eye24Regular className={styles.acknowledgedIcon} />}
                >
                    {data.acknowledgedCount.toString()}
                </TableCellLayout>
            </Tooltip>
        </div>
    );
};

export default BroadcastMessageStats;
